module.exports = __webpack_public_path__ + "images/dashboard-delay-statistics-no-color-95ff77d803c6e8a2c24e8451721356a1.png";